import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  rendezVousTitle,
  rendezVousSubContainerWithStep,
} from "../Part3/rendez-vous-part-3.module.scss"
import {
  rendezVousPart5HeaderContainer,
  rendezVousPart5ChoiceWeekContainer,
  rendezVousPart5CreneauxContainer,
  rendezVousPart5WeekArrowRight,
  rendezVousPart5WeekArrowLeft,
  rendezVousPart5DatePickerContainer,
} from "./rendez-vous-part-5.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
  RendezVousPart5WeekButton,
} from "../rendez-vous-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"
import { RendezVousPart5DayColumn } from "./rendez-vous-part-5-day-column.js"
import arrowBlack from "gatsby-theme-blank/src/images/full-arrow-black.svg"
import DatePicker, { registerLocale } from "react-datepicker"
import fr from "date-fns/locale/fr"
import "react-datepicker/dist/react-datepicker.css"

export const RendezVousPart5 = ({
  creneauxDisponibles,
  changeWeekOffset,
  changeCreneau,
  creneauChoisi,
  loadingLock,
  step,
  stepRefs,
}) => {
  const today = new Date()
  const [datePickerDate, setDatePickerDate] = useState(new Date())
  const handleChange = (selectedDate) => {
    setDatePickerDate(selectedDate)
    const todayStart = startOfWeek(today)
    const selectedStart = startOfWeek(selectedDate)
    const diffInMs = selectedStart.getTime() - todayStart.getTime()
    changeWeekOffset(Math.floor(diffInMs / (7 * 24 * 60 * 60 * 1000)), true)
  }

  const startOfWeek = (date) => {
    const monday = new Date(date)
    const day = monday.getDay()
    const diff = (day === 0 ? -6 : 1) - day
    monday.setDate(monday.getDate() + diff)
    monday.setHours(0, 0, 0, 0)
    return monday
  }

  registerLocale("fr", fr)
  return (
    <RendezVousSubContainer className={rendezVousSubContainerWithStep}>
      <StepIndicator step={step} refs={stepRefs} />
      <div className={rendezVousPart5HeaderContainer}>
        <RendezVousTitle className={rendezVousTitle}>
          Choix d&apos;un créneau de rendez-vous
        </RendezVousTitle>
        <div className={rendezVousPart5ChoiceWeekContainer}>
          <RendezVousPart5WeekButton onClick={() => changeWeekOffset(-1)}>
            <img
              className={rendezVousPart5WeekArrowLeft}
              src={arrowBlack}
              width={15}
              height={15}
            />{" "}
            Semaine précédente
          </RendezVousPart5WeekButton>
          <RendezVousPart5WeekButton onClick={() => changeWeekOffset(1)}>
            Semaine suivante{" "}
            <img
              className={rendezVousPart5WeekArrowRight}
              src={arrowBlack}
              width={15}
              height={15}
            />
          </RendezVousPart5WeekButton>
        </div>
      </div>
      <div className={rendezVousPart5DatePickerContainer}>
        <p>Sélectionner une semaine spécifique</p>
        <DatePicker
          locale="fr"
          selected={datePickerDate}
          calendarStartDay={1}
          onChange={handleChange}
          dateFormat="dd/MM/yyyy"
        />
      </div>

      {loadingLock && (
        // TODO Faire un truc beau...
        <div>Chargement des créneaux en cours...</div>
      )}
      {!loadingLock && (
        <div className={rendezVousPart5CreneauxContainer}>
          {creneauxDisponibles &&
            Object.keys(creneauxDisponibles).map((jour, indexJour) => (
              <RendezVousPart5DayColumn
                key={indexJour}
                jour={jour}
                creneauxDisponibles={creneauxDisponibles[jour]}
                changeWeekOffset={changeWeekOffset}
                changeCreneau={changeCreneau}
                creneauChoisi={creneauChoisi}
              />
            ))}
        </div>
      )}
    </RendezVousSubContainer>
  )
}

RendezVousPart5.propTypes = {
  creneauxDisponibles: PropTypes.object,
  changeWeekOffset: PropTypes.func,
  changeCreneau: PropTypes.func,
  creneauChoisi: PropTypes.string,
  loadingLock: PropTypes.bool,
  step: PropTypes.number,
  stepRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
